<script>
// import QuitBtn from '@/components/common/QuitBtn.vue'
// import quit from '@/common/quit'
const MapRoute = {
  ROLE_AGENT: "/index/agencyAccounts",
  ROLE_GROUP_OPTOMETRIST: "/index/visionTrainTrack",
  ROLE_AGENT_OPTOMETRIST: "/index/visionTrainTrack",
  ROLE_DOCTOR: "/index/patientManagement",
  ROLE_SUPER_ADMIN: "/index/groupAccounts",
  ROLE_REGION_MANAGER: "/index/medicalEstablishment",
  ROLE_STATION_MANAGER: "/index/visionTrainTrack"
};
export default {
  // components: {
  //     QuitBtn,
  //     quit
  // },
  data() {
    const name = localStorage.getItem("loginName");
    return {
      name,
      stationName: undefined,
      stationList: [],
      popoverControl: false
      // showAbout: false,
      // version: packageJSON.version,
      // showQuitConfirm: false,
    };
  },
  computed: {
    hi() {
      return `欢迎：${this.name}`;
    }
    // inElectron() {
    //     return this.$electron
    // }
  },
  created() {
    const stationName = this.$cookie.get("stationName");
    const ROLE_AGENT_OPTOMETRIST =
      localStorage.getItem("roles").indexOf("ROLE_AGENT_OPTOMETRIST") > -1;
    const ROLE_DOCTOR =
      localStorage.getItem("roles").indexOf("ROLE_DOCTOR") > -1;
    const ROLE_STATION_MANAGER =
      localStorage.getItem("roles").indexOf("ROLE_STATION_MANAGER") > -1;
    if (ROLE_AGENT_OPTOMETRIST || ROLE_DOCTOR || ROLE_STATION_MANAGER) {
      this.stationName = stationName;
      this.getStationList();
    }
  },
  methods: {
    async getStationList() {
      let stationList = await this.$http.getAgentStationList();
      let hadDirector = false;
      const AgentStationList = stationList.map(o => {
        if (o.isDirector) {
          hadDirector = true;
        }
        return {
          label: `${o.name}${o.isDirector ? "（主管医院）" : ""}`,
          keyName: o.stationUUID,
          director: o.isDirector,
          coursePrice: o.coursePrice
        };
      });
      console.log('>>>>>', hadDirector)
      this.$cookie.set("hadDirector", hadDirector);
      this.stationList = AgentStationList;
    },
    onSelectStation(station) {
      const ROLE_AGENT_OPTOMETRIST =
        localStorage.getItem("roles").indexOf("ROLE_AGENT_OPTOMETRIST") > -1;
      this.$cookie.set("stationId", station.keyName);
      this.$cookie.set("stationName", station.label);
      this.$cookie.set("stationDirector", station.director);
      this.$cookie.set("stationCoursePrice", station.coursePrice);
      sessionStorage.clear();
      this.stationName = station.label;
      this.popoverControl = false;
      if (ROLE_AGENT_OPTOMETRIST || ROLE_STATION_MANAGER) {
        if (this.$route.path !== MapRoute["ROLE_AGENT_OPTOMETRIST"]) {
          this.$router.push({
            path: MapRoute["ROLE_AGENT_OPTOMETRIST"]
          });
        }
      } else {
        if (this.$route.path !== MapRoute["ROLE_DOCTOR"]) {
          this.$router.push({
            path: MapRoute["ROLE_DOCTOR"]
          });
        }
      }
      this.$emit("routerRefresh");
    }
  }
};
</script>

<template>
  <div class="TheHeader">
    <img src="@/assets/header_logo.svg" />
    <span class="line" />
    <h1>视感知觉训练软件后台管理</h1>
    <p class="hi" v-if="name">{{name}}</p>
    <el-popover
      placement="bottom"
      width="200"
      v-model="popoverControl"
      trigger="click"
      popper-class="selectStationPopover"
    >
      <div
        v-for="(item,index) in stationList"
        class="selectItem"
        @click="onSelectStation(item)"
        :key="item.keyName + index "
      >{{item.label}}</div>
      <p class="hi" slot="reference" v-if="stationName">
        （{{stationName}}）
        <i class="el-icon-arrow-down"></i>
      </p>
    </el-popover>
  </div>
</template>

<style lang="scss">
@import "@/css/color.scss";

.TheHeader {
  height: 64px;
  background-color: #fff;
  flex-shrink: 0;
  box-sizing: border-box;
  border-bottom: 1px solid #e4e8eb;
  padding-left: 20px;
  display: flex;
  align-items: center;

  img {
    width: 50px;
    height: 40px;
  }

  .line {
    width: 1px;
    height: 40px;
    background-color: #e4e8eb;
    margin-left: 15px;
  }

  h1 {
    font-size: 18px;
    color: #909191;
    line-height: 24px;
    flex-grow: 1;
    margin-left: 15px;
  }

  .hi {
    font-size: 14px;
    margin-right: 15px;
    color: rgba(10, 33, 54, 1);
  }
}

.selectStationPopover {
  padding: 0 !important;
  max-height: 350px;
  overflow-y: auto;
  .selectItem {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(97, 98, 102, 1);
    line-height: 35px;
    padding: 5px 15px;
    cursor: pointer;

    &:hover {
      background-color: rgba(246, 247, 250, 1);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index/TheHeader.vue